import { render } from "./AStasks.vue?vue&type=template&id=867a0f86&scoped=true"
import script from "./AStasks.vue?vue&type=script&lang=js"
export * from "./AStasks.vue?vue&type=script&lang=js"

import "./AStasks.vue?vue&type=style&index=0&id=867a0f86&scoped=true&lang=css"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-867a0f86"]])

export default __exports__